import styled from 'styled-components';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';

export const StyledGrid = styled(Grid)`
  text-align: center;
`;

StyledGrid.displayName = 'StyledGrid';
